export default __webpack_public_path__ + "static/media/bra-arte-6.abd34b1e.webp";